var Window = require('ember-window')

module.exports = Window.extend({
    layout: require('../templates/components/invoice-reconciliation-modal'),

    applyModalMask: false,

    customEvent: Ember.inject.service(),

    userOrganizations: Em.inject.service(),

    organization: Em.computed.oneWay('userOrganizations.activeOrganization'),

    invoiceId: null, // set when invoking the modal

    openedFromInvoiceDetailsPage: false, // set when invoking the modal

    customActions: {
        closeEmber: function() {
            /** This saves from an unnecessary data reload */
            if (this.get('openedFromInvoiceDetailsPage')) {
                var controller = this.container.lookup('controller:invoice-index')
                if (controller) {
                    controller.send('reloadInvoiceData')
                }
            }
            this.close()
        }
    }
})
